export const MAX_DATASETS_PER_WORKSPACE = 8;
export const MAX_FUNCTIONS_PER_WORKSPACE = 5;
export const MAX_COLUMNS_PER_DATASET = 120;
